import { useMemo, useState, useEffect } from "react";
import "../../styles/ComponentStyles/Time.css";

/**
 * IST OFFICE SLOTS (SOURCE OF TRUTH)
 * 9 AM → 5 PM IST
 */
const OFFICE_SLOTS_IST = [
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
];

const OFFICE_TZ = "Asia/Kolkata";

/**
 * Convert IST slot → User Local Label (12-hour format)
 */
const istToUserLabel = (selectedDate, istTime) => {
  const [dd, mm, yyyy] = selectedDate.split("/");
  const [hh, min] = istTime.split(":").map(Number);

  const istDate = new Date(
    Date.UTC(yyyy, mm - 1, dd, hh - 5, min - 30, 0)
  );

  return istDate.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

/**
 * Build IST Date object for logic
 */
const buildISTDate = (selectedDate, istTime) => {
  const [dd, mm, yyyy] = selectedDate.split("/");
  const [hh, min] = istTime.split(":").map(Number);

  return new Date(
    Date.UTC(yyyy, mm - 1, dd, hh - 5, min - 30, 0)
  );
};

/**
 * YOUR LOGIC — UNCHANGED
 */
const getActiveSlotIndex = (selectedDate, nowIST, slotsIST) => {
  for (let i = 0; i < slotsIST.length; i++) {
    const slotStart = buildISTDate(selectedDate, slotsIST[i]);
    if (!slotStart) continue;

    // If current time has reached or passed this slot's start time,
    // this slot is no longer selectable
    if (nowIST >= slotStart) {
      continue;
    }

    // First future slot found
    return i;
  }

  // If all slots are past, disable all
  return slotsIST.length;
};


export default function TimeSlots({
  selectedDate,
  selectedTime,
  onSelect,
}) {
  /**
   * LIVE SYSTEM TIME
   */
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 30000);

    return () => clearInterval(timer);
  }, []);

  // Your 12-hour clock (UNCHANGED)
  const hours = time.getHours() % 12 || 12;
  const minutes = time.getMinutes().toString().padStart(2, "0");
  const ampm = time.getHours() >= 12 ? "PM" : "AM";


  /**
   * SLOT COMPUTATION (LOGIC PRESERVED)
   */
  const slots = useMemo(() => {
    if (!selectedDate) {
      return OFFICE_SLOTS_IST.map((ist) => ({
        label: ist,
        disabled: true,
      }));
    }

    // Current time in IST
    const nowIST = new Date(
      new Date().toLocaleString("en-US", {
        timeZone: OFFICE_TZ,
      })
    );

    const [dd, mm, yyyy] = selectedDate.split("/");
    const selectedDay = new Date(yyyy, mm - 1, dd);

    const isToday =
      selectedDay.toDateString() ===
      new Date(
        nowIST.getFullYear(),
        nowIST.getMonth(),
        nowIST.getDate()
      ).toDateString();

    // NOT today → all open (UNCHANGED BEHAVIOR)
    if (!isToday) {
      return OFFICE_SLOTS_IST.map((ist) => ({
        label: istToUserLabel(selectedDate, ist),
        disabled: false,
      }));
    }

    // TODAY → your slot logic
    const activeIndex = getActiveSlotIndex(
      selectedDate,
      nowIST,
      OFFICE_SLOTS_IST
    );

    return OFFICE_SLOTS_IST.map((ist, index) => ({
      label: istToUserLabel(selectedDate, ist),
      disabled: index < activeIndex,
    }));
  }, [selectedDate, time]);

  return (
    <>
      <h4 className="time-title">
        Available Time Slots (GMT +5:30)
      </h4>

  

      <div className="time-grid">
        {slots.map(({ label, disabled }) => (
          <button
            key={label}
            className={`time-slot ${
              selectedTime === label ? "active" : ""
            } ${disabled ? "disabled" : ""}`}
            disabled={disabled}
            onClick={() => !disabled && onSelect(label)}
            type="button"
          >
            {label}
          </button>
        ))}
      </div>
    </>
  );
}